// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags{position:relative;margin:0 0 10px 20px}`, "",{"version":3,"sources":["webpack://./src/common/components/Tag/Tags.scss"],"names":[],"mappings":"AAAA,MACE,iBAAA,CACA,oBAAA","sourcesContent":[".tags {\n  position: relative;\n  margin: 0 0 10px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
